module.exports = __webpack_public_path__ + "img/20.c7eb80dc.png";